import { useGlobal } from "@/app/store/global"
import { prefetchMe } from "@/features/auth/api/use-fetch-me"
import { useAuthWithOneIdCode } from "@/features/auth/api/use-fetch-one-url"
import { Auth } from "@/shared/lib"
import { Notice } from "@/shared/utils/notice"
import { t } from "i18next"
import Cookies from "js-cookie"
import { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"

export default function OneIdRedirectPage() {
  const [params] = useSearchParams()
  const { mutate: authenticate, isPending } = useAuthWithOneIdCode()
  const navigate = useNavigate()

  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  useEffect(() => {
    const code = params.get("code")
    if (code) {
      authenticate(code, {
        onSuccess: response => {
          const data = response
          if (data.session_id) {
            Cookies.set("session_id", data.session_id, { expires: 0.0208 })
            navigate("/auth/role-select")
          } else {
            Auth.setToken(data.access, { expires: 1 })
            Auth.setRefreshToken(data.refresh, { expires: 7 })
            prefetchMe()
            useGlobal.saveUser(data.user)
            navigate("/dashboard", { replace: true })
          }
        },
        onError: (error: Error) => {
          if ((error as any).status === 404) {
            Notice.error(t("auth:userNotFound"))
          } else {
            setErrorMessage(t("auth:errorOccurred"))
          }
          setTimeout(() => {
            navigate("/dashboard", { replace: true })
          }, 3000)
        }
      })
    } else {
      setErrorMessage("No code provided in the URL.")
    }
  }, [params])

  return <div>{isPending ? t("auth:loading") : errorMessage ? errorMessage : t("auth:loading")}</div>
}
